import Constants from "./Constants";
import views from "./views";

const viewMap = new Map();
viewMap.set(Constants.VIEW_CHOOSE_SETUP_TYPE, {
  comp: views.ChooseSetupType,
  view: Constants.VIEW_CHOOSE_SETUP_TYPE,
  desc: "Blog Setup Type",
});

viewMap.set(Constants.VIEW_SETUP_NOT_FOUND, {
  comp: views.SetupNotFound,
  view: Constants.VIEW_SETUP_NOT_FOUND,
  desc: "Blog Setup Request Not Found",
});

viewMap.set(Constants.VIEW_PREFERRED_DOMAIN, {
  comp: views.PreferredDomain,
  view: Constants.VIEW_PREFERRED_DOMAIN,
  desc: "Set Blog Domain",
});

viewMap.set(Constants.VIEW_CURRENT_BLOG_DOMAIN, {
  comp: views.CurrentBlogDomain,
  view: Constants.VIEW_CURRENT_BLOG_DOMAIN,
  desc: "Current Blog",
});

viewMap.set(Constants.VIEW_COMPLETE, {
  comp: views.Complete,
  view: Constants.VIEW_COMPLETE,
  desc: "Finish",
});

viewMap.set(Constants.VIEW_CURRENT_BLOG_LOGIN, {
  comp: views.CurrentBlogLogin,
  view: Constants.VIEW_CURRENT_BLOG_LOGIN,
  desc: "Current Blog Login",
});

viewMap.set(Constants.VIEW_CONFIRM, {
  comp: views.Confirm,
  view: Constants.VIEW_CONFIRM,
  desc: "Review",
});

viewMap.set(Constants.VIEW_UPDATE_START, {
  comp: views.UpdateStart,
  view: Constants.VIEW_UPDATE_START,
  desc: "Status",
});

export default viewMap;
